import { render, staticRenderFns } from "./StoreBrandBadge.vue?vue&type=template&id=1c94cc23&scoped=true"
import script from "./StoreBrandBadge.vue?vue&type=script&lang=js"
export * from "./StoreBrandBadge.vue?vue&type=script&lang=js"
import style0 from "./StoreBrandBadge.vue?vue&type=style&index=0&id=1c94cc23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c94cc23",
  null
  
)

export default component.exports